const object = {
  fontFamily: [
    'Poppins',
    'Roboto',
    'sans-serif'
  ].join(',')
}

export default object
